import { render, staticRenderFns } from "./EditDueDate.vue?vue&type=template&id=01424083&"
import script from "./EditDueDate.vue?vue&type=script&lang=js&"
export * from "./EditDueDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports